import React from 'react';

interface IndustryCardType {
  type: string;
  title: string;
  link: {
    url: string;
    text: string;
  };
  imageUrl: string;
}

interface IndustryCardProps {
  card: IndustryCardType;
  theme?: 'light' | 'dark';
}

function IndustryCard({ card, theme = 'light' }: IndustryCardProps) {
  const { type, title, link, imageUrl } = card;

  return (
    <div
      className={`au-flex au-flex-col au-h-full au-bg-black au-rounded-lg au-overflow-hidden au-border ${
        theme === 'dark' ? 'au-border-gray-700' : 'au-border-gray-200'
      }`}
    >
      <div className="au-flex au-flex-col au-p-6 au-min-h-[300px] au-justify-between">
        <div>
          <p className="au-text-sm au-font-medium au-text-white au-mb-4">
            {type}
          </p>
          <h2 className="au-text-[26px] au-font-bold au-mb-4 au-text-white">
            {title}
          </h2>
        </div>
        <div className="au-mt-auto">
          <a
            href={link.url}
            className="au-inline-flex au-text-[14px] au-items-center au-text-white hover:au-text-blue-800 au-transition-colors au-gap-2"
          >
            <svg
              width="12"
              height="12"
              viewBox="0 0 12 12"
              fill="none"
              className="au-text-white"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M6.55554 1.65625L10.8991 5.99985M10.8991 5.99985L6.55554 10.3434M10.8991 5.99985H1.10059"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            {link.text}
          </a>
        </div>
      </div>
      <div className="au-aspect-video au-relative au-w-full au-h-full">
        <img
          src={imageUrl}
          alt={title}
          className="au-object-cover au-w-full au-h-full"
        />
      </div>
    </div>
  );
}

export default IndustryCard;
